// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doctemplate__main{min-height:0 !important}`, "",{"version":3,"sources":["webpack://./../documentLayouts/src/documentLayouts/print.useable.scss"],"names":[],"mappings":"AAIA,mBACE,uBAAA","sourcesContent":["/*\n * Print CSS for app (loaded when print button pressed)\n *\n */\n.doctemplate__main {\n  min-height: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
